import React from 'react'
import Loading from '../Loading'
import jobRepo from '../../requests/jobs'
import { Chart } from 'react-google-charts'
import WidgetHeader from './WidgetHeader'
import moment from 'moment'

export default class JobByType extends React.Component {
  constructor(props, context) {
    super(props, context);
    this.state = {
      loading: false,
      options: {
        chartArea: {left:30,top:8,width:'80%',height:'90%'},
        legend: 'none',
      },
      time: moment().format('YYYY-MM-DD'),
      data: [
      ],
    }
  }
  componentWillMount () {
    if(!this.props.time || !this.state.time){
      this.setState({time: moment().format('YYYY-MM-DD'), loading: true})
    }
    this.loadData()
  }
  loadData() {
    // this.setState({loading: true})
    jobRepo.getJobCounterByType(this.state.time).then(data => {
      let parser = [['Jobs', 'Amount per Date']]
      for (let item of data) {
        parser.push(item)
      }
      this.setState({ data: parser, loading: false})
    })
  }
  async onTimeChange(time){
    await this.setState({time})
    this.loadData()
  }
  render(){
    if(this.state.loading === true){
      return (<Loading/>)
    }
    const time_opt = [
      { value: '12', label: 'Last 12 Hours' },
      { value: '24', label: 'Last 24 Hours' },
      { value: `${2 * 24}`, label: 'Last 2 Days' },
      { value: `${5 * 24}`, label: 'Last 5 Days' },
      { value: `${7 * 24}`, label: 'Last Week' }
    ]
    return(
      <div>
      <WidgetHeader title = 'By Types' options = {time_opt} time = {this.state.time} onChange={(time) =>{this.onTimeChange(time)}}/>
      <div className={'col-md-12'}>
        <Chart
          chartType="PieChart"
          data={this.state.data}
          options={this.state.options}
          graph_id="PieChart-JobByTypes"
          width={'100%'}
          height={'250px'}
          // legend_toggle
        />
      </div>
      </div>
    )
  }
}


// WEBPACK FOOTER //
// ./src/components/dashboard/JobByType.js